<template>
  <div class="sidebar-search-container">
    <div class="row results-info-row">
      <p class="results-info-p">
        <span class="results-count">
          {{ resultsCount }}
        </span>
        <span class="text-results"> resultaten</span>
      </p>
    </div>

    <div class="filter-results-title">
      <span class="title"> Filter resultaten </span>
    </div>
    <div class="row reset-btns justify-between">
      <span class="active-filters-count q-mt-sm"
        >Actieve filters: {{ activeFiltersCount }}</span
      >

      <div class="q-mt-md">
        <button class="reset-button" v-on:click="resetSearch(false)">
          <span class="reset-clear">Reset</span>
        </button>
        <span class="slash"> / </span>

        <button class="reset-button" v-on:click="resetSearch(true)">
          <span class="reset-clear">Wis</span>
        </button>
      </div>
    </div>

    <div class="row" v-if="isVind">
      <q-toggle
        v-model="isApplyingFilters"
        label="Pas filters uit je profiel toe"
        id="v-step-11"
      />
    </div>

    <FilterCheckBox
      class="sidebar-margin item-width statuses-box white-bg-box"
      id="v-step-0"
    />

    <default-tree
      class="sidebar-margin item-width white-bg-box"
      style="min-width: 280px; width: 27vw"
      :nodesState="audienceNodes.options"
      :heading="audienceNodes.label"
      :filtering="true"
      :profileSearchFlag="profileSearchFlag"
      :savedTagsString="savedAudiencesString"
      ref="tree"
    />

    <default-tree
      class="sidebar-margin item-width white-bg-box"
      :nodesState="purposesNodes.options"
      :heading="purposesNodes.label"
      :filtering="true"
      :profileSearchFlag="profileSearchFlag"
      :savedTagsString="savedPurposesString"
      ref="tree2"
    />

    <div
      class="filter-box sidebar-margin item-width orgs-box white-bg-box"
      v-if="!hideLocations"
    >
      <div class="row justify-between">
        <span class="org-heading">Locatie </span>
      </div>
      <div class="row start orgs-select">
        <q-select
          outlined
          bg-color="white"
          v-model="selectedLocations"
          multiple
          :options="filterLocationsTags"
          option-value="label"
          option-label="label"
          use-input
          label="Zoek een locatie gemeente of provincie"
          input-debounce="0"
          behavior="menu"
          use-chips
          @filter="filterLocationsFn"
          style="width: 100%"
          dense
          ref="locationsSelectInput"
          @update:model-value="setInput()"
          clearable
        >
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey"> No results </q-item-section>
            </q-item>
          </template>
        </q-select>
      </div>
    </div>

    <default-tree
      class="sidebar-margin item-width schemetype-tree white-bg-box"
      :nodesState="schemeTypesNodes.options"
      :heading="schemeTypesNodes.label"
      :profileSearchFlag="profileSearchFlag"
      :savedTagsString="savedSchemeTypesString"
      ref="tree3"
    />

    <!-- <default-tree
      class="sidebar-margin item-width projecttype-tree white-bg-box"
      :nodesState="projectTypesNodes.options"
      :heading="projectTypesNodes.label"
      :profileSearchFlag="profileSearchFlag"
      :savedTagsString="savedProjectTypesString"
      ref="tree4"
    /> -->

    <div class="filter-box sidebar-margin item-width white-bg-box">
      <div class="row justify-between">
        <span class="org-heading">Openstelling tussen</span>
        <i
          class="las la-2x la-times-circle clear-icon"
          @click="resetDatesRange()"
        >
          <q-tooltip> Filter leegmaken </q-tooltip>
        </i>
      </div>

      <q-input
        class="budget-input"
        bg-color="white"
        v-model="daysRangeModel"
        outlined
        dense
        @click="$refs.qDateProxy.show()"
        :update="updateRange()"
      >
        <template v-slot:append>
          <q-icon name="event" class="cursor-pointer datepicker-icon">
            <q-popup-proxy
              ref="qDateProxy"
              transition-show="scale"
              transition-hide="scale"
            >
              <q-date range v-model="days" mask="DD-MM-YYYY">
                <div class="row items-center justify-end">
                  <q-btn v-close-popup label="Sluiten" color="primary" flat />
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>

    <div class="filter-box sidebar-margin item-width white-bg-box">
      <div class="row justify-between">
        <span class="org-heading no-margin-top">Bijdrage</span>

        <i class="las la-2x la-times-circle clear-icon" @click="resetBudgets()">
          <q-tooltip>Filter leegmaken </q-tooltip></i
        >
      </div>

      <div class="row start">
        <q-input
          v-model.number="min"
          type="number"
          min="0"
          label="Minimaal €"
          class="budget-input"
          bg-color="white"
          outlined
          dense
        />
      </div>

      <div class="row start">
        <q-input
          outlined
          v-model.number="max"
          type="number"
          min="0"
          label="Maximaal €"
          bg-color="white"
          style="width: 100%"
          dense
        />
      </div>
    </div>

    <div class="filter-box item-width orgs-box white-bg-box">
      <span class="org-heading no-margin-top">Verstrekker(s) </span>
      <div class="row start orgs-select">
        <q-select
          outlined
          bg-color="white"
          v-model="organisationsInclude"
          multiple
          :options="filterOrganisationsInclude"
          use-chips
          option-value="name"
          class="budget-input"
          option-label="name"
          label="Zoek alleen in"
          use-input
          input-debounce="0"
          behavior="menu"
          @filter="filterOrganisationsIncludeFn"
          dense
          ref="organisationsIncludeSelect"
          @update:model-value="setInput()"
          clearable
        />
      </div>

      <div class="row start orgs-select">
        <q-select
          outlined
          bg-color="white"
          v-model="organisationsExclude"
          multiple
          :options="filterOrganisationsExclude"
          use-chips
          option-value="name"
          style="width: 100%"
          option-label="name"
          label="Zoek niet in"
          use-input
          input-debounce="0"
          behavior="menu"
          @filter="filterOrganisationsExcludeFn"
          dense
          ref="organisationsExcludeSelect"
          @update:model-value="setInput()"
          clearable
        />
      </div>
    </div>

    <AdvancedFilters class="adv-filters-box" ref="advancedFiltersBox" />

    <q-dialog v-model="showProfileNotSetWarning">
      <q-card>
        <q-card-section class="row">
          <i class="las la-2x la-info-circle"></i>
          <span class="q-ml-sm"> Er is geen profiel ingesteld! </span>
        </q-card-section>

        <q-card-actions align="right">
          <router-link
            :to="{ name: 'UserProfile', params: { tab: 'newsletter' } }"
            style="margin-right: 10px; text-decoration: none"
          >
            <q-btn
              color="primary"
              label="Ga naar profiel"
              @click="disableShowProfileNotSetWarning()"
            />
          </router-link>
          <q-btn
            outline
            label="Ok"
            color="primary"
            @click="disableShowProfileNotSetWarning()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="showAppliedFiltersInfo">
      <q-card>
        <q-card-section class="row">
          <i class="las la-2x la-info-circle"></i>
          <span class="q-ml-sm"> Profiel is nu toegepast op de filters! </span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            outline
            label="Ok"
            color="primary"
            @click="disableShowAppliedFiltersInfo()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { onMounted, ref, watch } from 'vue';
import { mapState } from 'vuex';
import { computed } from 'vue';
import store from '../../store/index.js';
import DefaultTree from './DefaultTree.vue';
import FilterCheckBox from './StatusesCheckBox.vue';
import AdvancedFilters from '../search-components/AdvancedFilters.vue';
import FiltersService from '../../services/filters.service';
import OrganisationsService from '../../services/organisations.service';
import SchemeUtils from '../../utils/schemes';
import moment from 'moment';
import UserService from '../../services/userprofile.service';
import NewsUtils from '../../utils/news';

export default {
  components: {
    FilterCheckBox,
    DefaultTree,
    AdvancedFilters,
  },
  setup() {
    const audienceNodes = computed({
      get: () => store.state.advancedSearch.audience,
    });

    const locationsNodes = computed({
      get: () => store.state.advancedSearch.locations,
    });

    const purposesNodes = computed({
      get: () => store.state.advancedSearch.purposes,
    });

    const schemeTypesNodes = computed({
      get: () => store.state.advancedSearch.schemeTypes,
    });

    const projectTypesNodes = computed({
      get: () => store.state.advancedSearch.projectTypes,
    });

    onMounted(async () => {
      FiltersService.getDefaultFilters();
      OrganisationsService.getAllOrganisationsWithBasicInfo();

      if (isApplyingFilters.value) {
        store.commit(
          'advancedSearch/updateSelectedAudiences',
          store.state.user.favoriteAudiencesIdsArray
        );
        //This is just hidden for now, don't remove it:
        /*
        store.commit(
          'advancedSearch/updateSelectedIndustries',
          store.state.user.favoriteIndustriesIdsArray
        );
        */
        store.commit(
          'advancedSearch/updateSelectedPurposes',
          store.state.user.favoritePurposesIdsArray
        );
        store.commit(
          'advancedSearch/updateSelectedLocations',
          store.state.user.selectedFavoriteLocations
        );
        refreshTrees();
      }
    });

    const locationsOptions = computed({
      get: () => store.state.advancedSearch.locationsOptions,
    });
    const filterLocationsTags = ref(locationsOptions.value);
    const selectedLocations = computed({
      get: () => store.state.advancedSearch.locationsSelectArray,
      set: async (value) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedSearch/updateSelectedLocations', value);
        if (!isSearchPaused.value) {
          await SchemeUtils.searchSchemes();
          await NewsUtils.searchNewsWithGrantsFilter();
        }
      },
    });

    const showProfileNotSetWarning = computed({
      get: () => store.state.user.showProfileNotSetWarning,
    });

    const showAppliedFiltersInfo = computed({
      get: () => store.state.user.showAppliedFiltersInfo,
    });

    const min = computed({
      get: () => store.state.advancedSearch.minBudget,
      set: async (value) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedSearch/updateMinBudget', value);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });
    const max = computed({
      get: () => store.state.advancedSearch.maxBudget,
      set: async (value) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedSearch/updateMaxBudget', value);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });

    const startDate = computed({
      get: () =>
        store.state.advancedSearch.startDate != null
          ? //   ? moment(store.state.advancedSearch.startDate).format('YYYY/MM/DD')
            moment(store.state.advancedSearch.startDate).format('DD-MM-YYYY')
          : null,
      set: async (value) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedSearch/updateStartDate', value);
        if (!isSearchPaused.value) {
          await SchemeUtils.searchSchemes();
          await NewsUtils.searchNewsWithGrantsFilter();
        }
      },
    });

    const endDate = computed({
      get: () =>
        store.state.advancedSearch.endDate != null
          ? //  ? moment(store.state.advancedSearch.endDate).format('YYYY/MM/DD')
            moment(store.state.advancedSearch.endDate).format('DD-MM-YYYY')
          : null,
      set: async (value) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedSearch/updateEndDate', value);
        if (!isSearchPaused.value) {
          await SchemeUtils.searchSchemes();
          await NewsUtils.searchNewsWithGrantsFilter();
        }
      },
    });

    const allOrganisations = computed({
      get: () => store.state.organisations.organisationsWithBasicInfo,
    });
    const filterOrganisationsInclude = ref(allOrganisations.value);
    const filterOrganisationsExclude = ref(allOrganisations.value);

    const organisationsInclude = computed({
      get: () => store.state.advancedSearch.organisationsInclude,
      set: async (val) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedSearch/updateOrganisationsInclude', val);
        if (!isSearchPaused.value) {
          await SchemeUtils.searchSchemes();
          await NewsUtils.searchNewsWithGrantsFilter();
        }
      },
    });

    const organisationsExclude = computed({
      get: () => store.state.advancedSearch.organisationsExclude,
      set: async (val) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedSearch/updateOrganisationsExclude', val);
        if (!isSearchPaused.value) {
          await SchemeUtils.searchSchemes();
          await NewsUtils.searchNewsWithGrantsFilter();
        }
      },
    });

    const updateSearchedLocations = (needle) => {
      store.commit('advancedSearch/updateSearchedLocations', needle);
    };

    const resultsCount = computed({
      get: () => store.state.advancedSearch.numberOfResults,
    });

    const profileSearchFlag = computed({
      get: () => store.state.user.isProfileSearch,
    });

    const savedAudiencesString = computed({
      get: () => store.state.user.savedAudienceTags,
    });

    const savedPurposesString = computed({
      get: () => store.state.user.savedPurposesTags,
    });

    const savedSchemeTypesString = computed({
      get: () => store.state.user.savedSchemeTypesTags,
    });

    const savedProjectTypesString = computed({
      get: () => store.state.user.savedProjectTypesTags,
    });

    //profile tags
    const favoriteAudience = computed({
      get: () => store.state.user.favoriteAudiencesIdsArray,
    });
    const favoritePurposes = computed({
      get: () => store.state.user.favoritePurposesIdsArray,
    });
    const favoriteLocations = computed({
      get: () => store.state.user.selectedFavoriteLocations,
    });
    //This is just hidden for now, don't remove it
    /*
    const favoriteIndustries = computed({
      get: () => store.state.user.favoriteIndustriesIdsArray,
    });
    */
    const tree = ref(null);
    const tree2 = ref(null);
    const tree3 = ref(null);
    //const tree4 = ref(null);
    const advancedFiltersBox = ref(null);

    const resetSearch = async (isClear) => {
      store.commit('advancedSearch/updateIsResetSearch', true);
      store.commit('advancedSearch/resetSearchFilter', isClear);

      advancedFiltersBox.value.resetValues();
      resetDatesRange();
      if (!isApplyingFilters.value) {
        tree3.value.resetTree();
        tree.value.resetTree();
        tree2.value.resetTree();
        //tree4.value.resetTree();
      }
      selectedLocations.value = [];
      if (isClear) {
        /*       tree.value.resetTree();
        tree2.value.resetTree();
        selectedLocations.value = []; */

        UserService.setApplyFilter(false);
        store.commit('user/setIsApplyingFilters', false);
      }

      if (!isClear && isApplyingFilters.value) {
        store.commit('advancedSearch/updateIsApplyingFiltersReset', true);
        //This is just hidden for now, don't remove it
        // if (showAdvancedFilters.value == true) {
        //   advancedFiltersBox.value.resetAndRefreshTree();
        // }
        store.commit(
          'advancedSearch/updateSelectedLocations',
          store.state.user.selectedFavoriteLocations
        );
        refreshTrees();
      }

      /*       
        if (!isClear && !isApplyingFilters.value) {
          UserService.setApplyFilter(true);
          store.commit('user/setIsApplyingFilters', true);
        } 
      */

      /*       
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      */
      store.commit('advancedSearch/updateIsResetSearch', false);
    };

    const days = computed({
      get: () => store.state.advancedSearch.daysRange,
      set: async (val) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('advancedSearch/updateDaysRange', val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      },
    });

    const locationsSelectInput = ref(null);
    const organisationsIncludeSelect = ref(null);
    const organisationsExcludeSelect = ref(null);

    const setInput = () => {
      locationsSelectInput.value.updateInputValue('');
      organisationsIncludeSelect.value.updateInputValue('');
      organisationsExcludeSelect.value.updateInputValue('');
    };

    const daysFrom = computed({
      get: () => store.state.advancedSearch.daysRange.from,
    });

    const daysTo = computed({
      get: () => store.state.advancedSearch.daysRange.to,
    });

    //  const daysRangeModel = ref([daysFrom.value, daysTo.value].join('/'));
    const daysRangeModel = ref(null);

    const updateRange = () => {
      daysRangeModel.value = [daysFrom.value, daysTo.value].join(' - ');
    };

    const resetSelectedLocations = async () => {
      locationsSelectInput.value.updateInputValue('');
      selectedLocations.value = null;
      store.commit('advancedSearch/updateSelectedLocations', '');
      if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
    };

    const resetDatesRange = async () => {
      daysRangeModel.value = '';
      store.commit('advancedSearch/updateDaysRange', { from: '', to: '' });
      if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
    };

    const resetBudgets = async () => {
      store.commit('advancedSearch/updateMinBudget', null);
      store.commit('advancedSearch/updateMaxBudget', null);
      if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
    };

    watch(selectedLocations, async () => {
      if (selectedLocations.value == null) {
        store.commit('advancedSearch/updateSelectedLocations', null);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      }
    });

    watch(organisationsExclude, async () => {
      if (organisationsExclude.value == null) {
        store.commit('advancedSearch/updateOrganisationsExclude', []);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      }
    });

    watch(organisationsInclude, async () => {
      if (organisationsInclude.value == null) {
        store.commit('advancedSearch/updateOrganisationsInclude', []);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
      }
    });

    const showAdvancedFilters = computed({
      get: () => store.state.advancedFilters.showAdvancedFilters,
    });

    const refreshTrees = async () => {
      tree.value.refreshTree(favoriteAudience.value);
      tree2.value.refreshTree(favoritePurposes.value);

      //This is just hidden for now, don't remove it
      // if (showAdvancedFilters.value == true) {
      //   advancedFiltersBox.value.refreshTree();
      // }

      if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
    };

    const activeFiltersCount = computed({
      get: () => store.state.advancedSearch.activeFiltersCount,
    });

    const activeFiltersLabel = ref(
      'Actieve filters: ' + activeFiltersCount.value
    );

    watch(activeFiltersCount, () => {
      activeFiltersLabel.value = 'Actieve filters: ' + activeFiltersCount.value;
    });

    const applyProfileFilters = (val) => {
      UserService.setApplyFilter(val);

      if (val) {
        if (
          favoriteAudience.value.length == 0 &&
          favoritePurposes.value.length == 0 &&
          //This is just hidden for now, don't remove it
          //&& favoriteIndustries.value.length == 0
          favoriteLocations.value.length == 0
        ) {
          store.commit('user/enableShowProfileNotSetWarning');
        } else {
          store.commit(
            'advancedSearch/updateSelectedAudiences',
            store.state.user.favoriteAudiencesIdsArray
          );
          //This is just hidden for now, don't remove it
          /*
          store.commit(
            'advancedSearch/updateSelectedIndustries',
            store.state.user.favoriteIndustriesIdsArray
          );
          */
          store.commit(
            'advancedSearch/updateSelectedPurposes',
            store.state.user.favoritePurposesIdsArray
          );
          store.commit(
            'advancedSearch/updateSelectedLocations',
            store.state.user.selectedFavoriteLocations
          );
          refreshTrees();

          store.commit('user/enableShowAppliedFiltersInfo');
        }
      } /* else {
        resetSearch(false);
      } */
    };

    const isApplyingFilters = computed({
      get: () => store.state.user.isApplyingFilters,
      set: (val) => {
        store.commit('advancedSearch/enableFiltersChange');
        store.commit('user/setIsApplyingFilters', val);
        applyProfileFilters(val);
      },
    });

    watch(
      () => isApplyingFilters.value,
      async (next, prev) => {
        if (!prev && next) {
          resetSearch(false);
          store.commit(
            'advancedSearch/updateSelectedAudiences',
            store.state.user.favoriteAudiencesIdsArray
          );
          //This is just hidden for now, don't remove it
          /*
          store.commit(
            'advancedSearch/updateSelectedIndustries',
            store.state.user.favoriteIndustriesIdsArray
          );
          */
          store.commit(
            'advancedSearch/updateSelectedPurposes',
            store.state.user.favoritePurposesIdsArray
          );
          store.commit(
            'advancedSearch/updateSelectedLocations',
            store.state.user.selectedFavoriteLocations
          );
          refreshTrees();
          if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
        } else if (prev && !next) {
          store.commit('advancedSearch/clearNewsletterFilters');
          tree.value.resetTree();
          tree2.value.resetTree();

          selectedLocations.value = [];
          if (!isSearchPaused.value) await SchemeUtils.searchSchemes();
        }
      }
    );

    const disableShowProfileNotSetWarning = () => {
      store.commit('user/disableShowProfileNotSetWarning');
    };

    const disableShowAppliedFiltersInfo = () => {
      store.commit('user/disableShowAppliedFiltersInfo');
    };

    const isSearchPaused = computed({
      get: () => store.state.advancedSearch.applySavedSearchPause,
    });
    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });
    const shortList = computed({
      get: () => store.state.advancedSearch.locationsOptions.length < 4,
    });
    const hideLocations = computed({
      get: () => !isVind.value && shortList.value,
    });

    return {
      hideLocations,
      isVind,
      isSearchPaused,
      showProfileNotSetWarning,
      disableShowProfileNotSetWarning,
      isApplyingFilters,
      applyProfileFilters,
      activeFiltersCount,
      activeFiltersLabel,
      resetBudgets,
      resetDatesRange,
      resetSelectedLocations,
      updateRange,
      daysRangeModel,
      daysFrom,
      daysTo,
      organisationsIncludeSelect,
      organisationsExcludeSelect,
      setInput,
      days,
      advancedFiltersBox,
      tree,
      tree2,
      tree3,
      //tree4,
      resetSearch,
      resultsCount,
      filterOrganisationsInclude,
      filterOrganisationsExclude,
      filterLocationsTags,
      locationsOptions,
      selectedLocations,
      startDate,
      endDate,
      store,
      audienceNodes,
      purposesNodes,
      locationsNodes,
      min,
      max,
      organisationsExclude,
      organisationsInclude,
      allOrganisations,
      schemeTypesNodes,
      projectTypesNodes,
      statusOpen: ref(true),
      statusFuture: ref(true),
      statusClosed: ref(false),
      profileSearchFlag,
      savedAudiencesString,
      savedPurposesString,
      savedSchemeTypesString,
      savedProjectTypesString,
      locationsSelectInput,
      favoriteAudience,
      favoritePurposes,
      favoriteLocations,
      //This is just hidden for now, don't remove it
      //favoriteIndustries,
      showAdvancedFilters,
      showAppliedFiltersInfo,
      disableShowAppliedFiltersInfo,
      refreshTrees,
      nodes: computed(() => store),
      computed: {
        ...mapState({
          filterActivities: (state) => state.advancedSearch.filterActivities,
        }),
      },
      methods: {
        updateFilter: function() {
          store.commit('advancedSearch/updateFilterActivities');
        },
        updateTreeData: function() {},
      },
      updateSearchedLocations,
      filterLocationsFn(val, update, abort) {
        if (val.length < 1) {
          abort();
          return;
        }
        update(() => {
          if (val === '') {
            filterLocationsTags.value = locationsOptions.value;
          } else {
            /*             locationsSelectInput.value.showPopup();
             */
            const needle = val.toLowerCase();

            filterLocationsTags.value = locationsOptions.value.filter(
              (v) =>
                v.label
                  .split(/,(.+)/)[0]
                  .toLowerCase()
                  .indexOf(needle) > -1
            );
          }
        });
      },
      filterOrganisationsIncludeFn(val, update) {
        update(() => {
          if (val === '') {
            filterOrganisationsInclude.value = allOrganisations.value;
          } else {
            const needle = val.toLowerCase();

            filterOrganisationsInclude.value = allOrganisations.value.filter(
              (v) => v.name.toLowerCase().indexOf(needle) > -1
            );
          }
        });
      },

      filterOrganisationsExcludeFn(val, update) {
        update(() => {
          if (val === '') {
            filterOrganisationsExclude.value = allOrganisations.value;
          } else {
            const needle = val.toLowerCase();

            filterOrganisationsExclude.value = allOrganisations.value.filter(
              (v) => v.name.toLowerCase().indexOf(needle) > -1
            );
          }
        });
      },
    };
  },
};
</script>
